<template>
  <div v-if="price">
    <span v-if="price.currency !== 'USD'">{{
      $texts('product.msrp')
    }}</span>
    {{ price.formatted }}
  </div>
</template>

<script lang="ts" setup>
import type { VariationPriceFragment } from '#graphql-operations'
import { Currency } from '#graphql-operations'
import { Region } from '~~/settings'

const props = defineProps<{
  prices: VariationPriceFragment[]
}>()

const { region } = useCountry()

/**
 * The matching price to display.
 */
const price = computed(() =>
  props.prices.find((v) => {
    if (region.value === Region.US) {
      return v.currency === Currency.USD
    } else if (region.value === Region.DAFI) {
      return v.currency === Currency.EUR
    } else if (region.value === Region.Switzerland) {
      return v.currency === Currency.CHF
    }
  }),
)
</script>
